export default __webpack_public_path__ + "static/media/close.98e1554d.svg";